import { useEffect } from 'react';
import { Prototype1Provider, usePrototype1 } from './Prototype1Context';
import Screen01Dashboard from './screens/Screen01Dashboard';
import Screen02CollegeEligibilityNotStarted from './screens/Screen02CollegeEligibilityNotStarted';
import Screen03EquityGapsDrafting from './screens/Screen03EquityGapsDrafting';
import Screen04ChatPanelClosed from './screens/Screen04ChatPanelClosed';
import Screen05DashboardReportOverview from './screens/Screen05DashboardReportOverview';
import Screen06SectionEditorAiDraft from './screens/Screen06SectionEditorAiDraft';
import Screen07DashboardAllSectionsComplete from './screens/Screen07DashboardAllSectionsComplete';
import Screen08FullReportReview from './screens/Screen08FullReportReview';

const ScreenSwitch = () => {
  const { currentScreen } = usePrototype1();
  switch (currentScreen) {
    case '01-dashboard':
      return <Screen01Dashboard />;
    case '02-college-eligibility-not-started':
      return <Screen02CollegeEligibilityNotStarted />;
    case '03-equity-gaps-drafting':
      return <Screen03EquityGapsDrafting />;
    case '04-chat-panel-closed':
      return <Screen04ChatPanelClosed />;
    case '05-dashboard-report-overview':
      return <Screen05DashboardReportOverview />;
    case '06-section-editor-ai-draft':
      return <Screen06SectionEditorAiDraft />;
    case '07-dashboard-all-sections-complete':
      return <Screen07DashboardAllSectionsComplete />;
    case '08-full-report-review':
      return <Screen08FullReportReview />;
    default:
      return null;
  }
};

const TAILWIND_SCRIPT_ID = 'prototypes-tailwind-cdn';
const INTER_LINK_ID = 'prototypes-inter-font';
const HIDE_APP_CHROME_STYLE_ID = 'prototypes-hide-app-chrome';

const Prototype1Page = () => {
  useEffect(() => {
    const tw = document.createElement('script');
    tw.id = TAILWIND_SCRIPT_ID;
    tw.src = 'https://cdn.tailwindcss.com';
    tw.onload = () => {
      const w = window as unknown as { tailwind?: { config?: Record<string, unknown> } };
      if (w.tailwind) {
        w.tailwind.config = { corePlugins: { preflight: false } };
      }
    };

    const inter = document.createElement('link');
    inter.id = INTER_LINK_ID;
    inter.rel = 'stylesheet';
    inter.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap';

    const hideAppChrome = document.createElement('style');
    hideAppChrome.id = HIDE_APP_CHROME_STYLE_ID;
    hideAppChrome.textContent = '.footer { display: none !important; }';

    document.head.append(tw, inter, hideAppChrome);

    return () => {
      document.getElementById(TAILWIND_SCRIPT_ID)?.remove();
      document.getElementById(INTER_LINK_ID)?.remove();
      document.getElementById(HIDE_APP_CHROME_STYLE_ID)?.remove();
    };
  }, []);

  return (
    <Prototype1Provider>
      <div className="tw relative w-full h-full overflow-hidden">
        <ScreenSwitch />
      </div>
    </Prototype1Provider>
  );
};

export default Prototype1Page;
